
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';

type HeaderProps = {
  setIsSidebarOpen: (isOpen: boolean) => void;
  userName?: string; // Add userName as an optional prop
};

const Header = ({ setIsSidebarOpen, userName }: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow z-10 sticky top-0">
      <div className="px-4 sm:px-6 lg:px-8 flex h-16 items-center justify-between">
        <div className="flex items-center">
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden mr-2"
            onClick={() => setIsSidebarOpen(true)}
          >
            <Menu size={24} />
            <span className="sr-only">Toggle menu</span>
          </Button>
          
          <div className="md:hidden flex items-center gap-2" onClick={() => navigate('/dashboard')} style={{cursor: 'pointer'}}>
            <img src="/lovable-uploads/95822005-216a-471c-aa2e-8f186810d92f.png" alt="Logo" className="h-12 w-auto" />
            <span className="text-xl font-bold text-darkgray hidden sm:inline-block">Snabbaupphandlingar</span>
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          {userName && (
            <span className="text-sm text-gray-600 hidden md:inline-block mr-2">
              Välkommen, {userName}
            </span>
          )}
          <Button variant="ghost" size="icon" className="relative">
            <Bell size={20} />
            <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-red-500"></span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
